import { graphql } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';
import React from 'react';
import StickyBox from 'react-sticky-box';

import RichTextConverter from '../components/Common/RichText/RichTextConverter';
import SmartLink from '../components/Common/SmartLink';
import Layout from '../components/Layouts/Layout';
import MarketingSeo from '../components/MarketingSeo';
import PageSection from '../components/PageSections/PageSection';
import { ReactComponent as Arrow } from '../images/icons/fs-lc-arrow.svg';
import * as styles from './profile.module.scss';

const Profile = ({ data: { page }, pageContext, location }) => {
  const prevPath = location?.state?.prevPath;
  const heroImg = page.heroImage;
  let hero;
  if (heroImg?.file?.contentType === 'image/svg+xml') {
    hero = <img src={heroImg?.file?.url} alt={heroImg?.title} />;
  } else if (heroImg?.gatsbyImageData) {
    hero = <GatsbyImage alt={heroImg?.title} image={heroImg?.gatsbyImageData} />;
  } else if (heroImg) {
    hero = <img src={heroImg?.file?.url} alt={heroImg?.title} />;
  }

  return (
    <Layout pageMeta={page.pageMetaData} isDach={pageContext.isDach}>
      <PageSection noPad={true} isTopSection className={styles.page}>
        <nav
          className={[styles.menu, styles.mobileBack].join(' ')}
          data-analytics-component={'profile-page-mobile-nav'}
        >
          <SmartLink to={prevPath ? prevPath : '/about-us/'}>
            <Arrow className={styles.left} /> Back
          </SmartLink>
        </nav>
        <div className={styles.layout}>
          <section className={styles.section} data-analytics-section={'profile-page'}>
            <nav className={[styles.menu, styles.desktopBack].join(' ')} data-analytics-component={'profile-page-nav'}>
              <SmartLink to={prevPath ? prevPath : '/about-us/'}>
                <Arrow className={styles.left} /> Back
              </SmartLink>
            </nav>
            <h1>{page?.pageTitle}</h1>
            <RichTextConverter className={styles.copy} copy={page?.body} />
            <nav className={styles.menu}>
              <SmartLink to={`/${pageContext.prevPage}/`}>
                <Arrow className={styles.left} /> Previous Profile
              </SmartLink>
              <SmartLink to={`/${pageContext.nextPage}/`}>
                Next Profile <Arrow />
              </SmartLink>
            </nav>
          </section>
          <div className={styles.hero}>
            <StickyBox offsetTop={84} offsetBottom={0}>
              {hero}
            </StickyBox>
          </div>
        </div>
      </PageSection>
    </Layout>
  );
};

export default Profile;

export const Head = ({ data: { page }, location }) => (
  <MarketingSeo meta={page.pageMetaData} slug={location.pathname} />
);

export const query = graphql`
  query ProfileTemplateQuery($slug: String!) {
    page: contentfulPageSimple(slug: { eq: $slug }) {
      pageTitle
      heroImage {
        title
        file {
          url
          contentType
        }
        gatsbyImageData
      }
      body {
        raw
      }
      pageMetaData {
        ... on Node {
          ...PageMetaData
        }
      }
    }
  }
`;
